import {
  OpenAPIConfig,
  IntegrationServicesClient,
} from '@resideo/web-integration-services-api-client';

/**
 * Factory function to create a configured RIS (Resideo Integration Services) API client.
 * 
 * @param platformApiUrl - Camera API base URL from shell config
 * @param getAccessToken - Function that returns the current access token or null
 * @returns Configured IntegrationServicesClient instance
 * 
 * @example
 * ```typescript
 * const risClient = createRisClient(platformApiUrl, getAccessToken);
 * const response = await risClient.accounts.getAccountData();
 * ```
 */
export function createRisClient(
  platformApiUrl: string,
  getAccessToken: () => string | null
): IntegrationServicesClient {
  const config: Partial<OpenAPIConfig> = {
    BASE: platformApiUrl,
    TOKEN: async () => {
      const token = getAccessToken();
      if (!token) {
        throw new Error('No access token available');
      }
      return token;
    },
  };

  return new IntegrationServicesClient(config);
}
